import styled, { css } from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledRegion = styled.div<{ innerRegion?: boolean }>(({ innerRegion, theme }) => {
  return css`
    background-color: ${theme.base.palette[
      innerRegion ? 'primary-background' : 'secondary-background'
    ]};
    padding: calc(4 * ${theme.base.spacing});
    display: flex;
    justify-content: center;

    button {
      height: max-content;
      align-self: center;
    }
  `;
});

StyledRegion.defaultProps = defaultThemeProp;
